/**
 * 15.09.2026 — Die Zerlegung ist nach shared/ gezogen.
 *
 * Martin, mit Foto (10/25, „Bereitet vor …", minutenlang): Der Server konnte
 * eine geoeffnete Datei nicht vorwaermen, weil nur der Browser wusste, wie
 * sie in Abschnitte zerfaellt — und der Zwischenspeicher haengt am Text des
 * Abschnitts. Jetzt lesen Browser und Server DIESELBE Zerlegung, wie beim
 * Spiegel (shared/vorlese-abschnitte.ts). Dieser Schatten bleibt, damit die
 * bestehenden Importe weitergehen.
 */
export * from "../../shared/doc-narration.js";
